export const COLORS = ["#FFE7A7", "#FFA7A7", "#bada72"];
